"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ButtonComponent.default;
  }
});

var _ButtonComponent = _interopRequireDefault(require("./Button-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }